import { render, staticRenderFns } from "./teStatistics.vue?vue&type=template&id=db7cbca6&scoped=true"
import script from "./teStatistics.vue?vue&type=script&lang=js"
export * from "./teStatistics.vue?vue&type=script&lang=js"
import style0 from "./teStatistics.vue?vue&type=style&index=0&id=db7cbca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db7cbca6",
  null
  
)

export default component.exports